import { APP_INITIALIZER, enableProdMode, LOCALE_ID, importProvidersFrom } from '@angular/core';

import { environment } from './environments/environment';
import { RouteReuseStrategy, PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { AuthService } from './app/auth/auth.service';
import { ScreenTrackingService, UserTrackingService, provideAnalytics, getAnalytics } from '@angular/fire/analytics';
import { CurrencyPipe, DatePipe, registerLocaleData } from '@angular/common';
import { provideFirebaseApp, getApp } from '@angular/fire/app';
import { provideAuth, initializeAuth, indexedDBLocalPersistence, getAuth } from '@angular/fire/auth';
import { Capacitor } from '@capacitor/core';
import { provideFirestore, initializeFirestore, connectFirestoreEmulator } from '@angular/fire/firestore';
import { provideStorage, getStorage, connectStorageEmulator } from '@angular/fire/storage';
import { provideFunctions, getFunctions, connectFunctionsEmulator } from '@angular/fire/functions';
import { bootstrapApplication } from '@angular/platform-browser';
import { IonicStorageModule } from '@ionic/storage-angular';
import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import ptBr from '@angular/common/locales/pt';
import { CampaignTrackingService } from './app/services/campaign-tracking.service';
import {
  createFirestoreLocalCacheSettings,
  getOrInitializeApp,
  prepareFirestoreCache,
  registerFirestoreCacheRecoveryHandler,
} from './app/utils/firestore-cache.util';

if (environment.production) {
  enableProdMode();
}

registerLocaleData(ptBr);

// Capture Google Ads campaign params before Angular bootstraps, otherwise the
// auth subscription redirect to /login wipes window.location.search.
CampaignTrackingService.captureFromUrl(window.location.href);
registerFirestoreCacheRecoveryHandler();

bootstrapApplication(AppComponent, {
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => prepareFirestoreCache(environment.firebase),
      multi: true,
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({
      useSetInputAPI: true, //allow to use signal input in modals
    }),
    importProvidersFrom(IonicStorageModule.forRoot()),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    AuthService,
    ScreenTrackingService,
    UserTrackingService,
    CurrencyPipe,
    DatePipe,
    { provide: LOCALE_ID, useValue: 'pt' },
    provideFirebaseApp(() => getOrInitializeApp(environment.firebase)),
    provideAnalytics(() => getAnalytics()),
    provideAuth(() => {
      if (Capacitor.isNativePlatform()) {
        return initializeAuth(getApp(), {
          persistence: indexedDBLocalPersistence
        });
      }
      else {
        return getAuth();
      }
    }),
    // provideAuth(() => {
    //   const auth = getAuth();
    //   if (environment.useEmulators) {
    //         connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
    //   }
    //   return auth;
    // }),
    // ServiceWorkerModule.register('ngsw-worker.js', {
    //   enabled: environment.production,
    //   registrationStrategy: 'registerWhenStable:30000'
    // }),
    provideFirestore(() => {
      const firestore = initializeFirestore(getApp(), {
        localCache: createFirestoreLocalCacheSettings(),
      });
      if (environment.useEmulators) {
        connectFirestoreEmulator(firestore, 'localhost', 9090);
      }
      return firestore;
    }),
    provideStorage(() => {
      const storage = getStorage();
      if (environment.useEmulators) {
        connectStorageEmulator(storage, 'localhost', 9199);
      }
      return storage;
    }),
    provideFunctions(() => {
      const functions = getFunctions(getApp());
      if (environment.useEmulators) {
        connectFunctionsEmulator(functions, 'localhost', 6001);
      }
      return functions;
    })
  ]
})
  .catch(err => console.log(err));


